// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, DialogActions } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { Mutation } from 'react-apollo'
import { fetchDailyManagement } from '../../dailyManagement/dailyManagementQueries'
import { i18n } from '../../index'
import { fetchDashboardStats } from '../../OldDashboard/oldDashboardQueries'
import css from './CustomPriceDialog.css'
import { getStaffingPlan, increaseSalesIncentiveProduct } from './incentivesPanelQueries'
import type { StaffingPlanVariables } from './types'
type CustomPriceDialogProps = {
  isOpen: boolean
  onClose: (...args: Array<any>) => any
  registerIncentiveSale: (...args: Array<any>) => any
  variables: StaffingPlanVariables
  stationId: string
  date: string
}
const defaultFormData = {
  euros: '',
  cents: '',
}

class CustomPriceDialog extends React.PureComponent<CustomPriceDialogProps> {
  state = {
    formData: { ...defaultFormData },
  }

  amountInEuros(cents: string, euros: string) {
    // verify value inputs first
    if (cents.includes('-') || cents.length > 2 || (euros.includes('-') ? euros.length > 4 : euros.length > 3)) {
      return 0
    }

    let roundedCents = ''

    if (cents.length === 0) {
      roundedCents = '00'
    } else if (cents.length === 1) {
      roundedCents = `0${cents}`
    } else {
      roundedCents = cents
    }

    return parseFloat(`${euros}.${roundedCents}`)
  }

  onEuroChange = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { registerIncentiveSale, salesIncentiveProductId } = this.props
    const amountInEuros = this.amountInEuros(this.state.formData.cents, this.state.formData.euros)
    registerIncentiveSale(onMutate, salesIncentiveProductId, '+', amountInEuros)
    //const amount = isEuroSale ? (isCustomPrice ? amountInEuros : price) : 1
    this.props.onClose()
    this.setState({
      formData: { ...defaultFormData },
    })
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { isOpen, onClose, variables, stationId, date } = this.props
    const { formData } = this.state
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>{i18n.t('employeeCard.customPrice')}</DialogTitle>
        <DialogContent>
          <Mutation
            mutation={increaseSalesIncentiveProduct}
            refetchQueries={() => [
              {
                query: getStaffingPlan,
                variables,
                skip: !variables || !variables.stationId || !variables.date,
              },
              {
                query: fetchDashboardStats,
                variables: {
                  stationId,
                },
              },
              {
                query: fetchDailyManagement,
                variables: {
                  stationId,
                  date: date,
                  mode: 'Day',
                  status: 'InProgress',
                },
              },
            ]}
          >
            {(onMutate) => (
              <form onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.formComponent}>
                <div className={css.euroSale}>
                  <input
                    type='number'
                    min='-999'
                    max='999'
                    placeholder='0'
                    value={formData.euros}
                    onChange={(e) => this.onEuroChange('euros', e.target.value)}
                    className={css.euroInput}
                  />
                  <input
                    type='number'
                    min='0'
                    max='99'
                    placeholder='00'
                    value={formData.cents}
                    onChange={(e) => this.onEuroChange('cents', e.target.value)}
                    className={css.centsInput}
                  />
                  <span className={css.euroSign}>€</span>
                </div>
                <DialogActions className={css.actions}>
                  <Button type='button' onClick={() => onClose()}>
                    {i18n.t('buttons.cancel')}
                  </Button>
                  <Button type='submit' color='primary'>
                    {i18n.t('buttons.save')}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Mutation>
        </DialogContent>
      </Dialog>
    )
  }
}

export default CustomPriceDialog
